module.exports = __webpack_public_path__ + "img/atop.55949741.png";